export default {
  inputTypes: {
    SiInputText: {
      id: 'SiInputText',
      name: 'Text Input',
      icon: 'short_text',
      format: 'text',
      layout: 'default',
      helpMarginAdjust: 16,
      attrs: {
        label: true,
        reportLabel: true,
        hint: true,
        help: true,
        canHaveRules: true
      }
    },
    SiInputTextarea: {
      id: 'SiInputTextarea',
      name: 'Textarea Input',
      icon: 'notes',
      format: 'text',
      layout: 'default',
      helpMarginAdjust: 16,
      attrs: {
        label: true,
        reportLabel: true,
        hint: true,
        help: true,
        canHaveRules: true
      }
    },
    SiInputCurrency: {
      id: 'SiInputCurrency',
      name: 'Currency Input',
      icon: 'attach_money',
      format: 'currency',
      layout: 'default',
      helpMarginAdjust: 16,
      attrs: {
        label: true,
        reportLabel: true,
        hint: true,
        help: true,
        cents: true,
        canHaveRules: true
      }
    },
    SiInputPercent: {
      id: 'SiInputPercent',
      name: 'Percent Input',
      icon: 'exposure_zero',
      format: 'percent',
      layout: 'default',
      helpMarginAdjust: 16,
      attrs: {
        label: true,
        reportLabel: true,
        hint: true,
        help: true,
        canHaveRules: true
      }
    },
    SiInputDate: {
      id: 'SiInputDate',
      name: 'Date Input',
      icon: 'date_range',
      format: 'date',
      layout: 'default',
      helpMarginAdjust: 16,
      attrs: {
        label: true,
        reportLabel: true,
        dateMinMax: true,
        hint: true,
        help: true,
        canHaveRules: true
      }
    },
    SiInputNumber: {
      id: 'SiInputNumber',
      name: 'Number Input',
      icon: 'exposure_plus_1',
      format: 'number',
      layout: 'default',
      helpMarginAdjust: 16,
      attrs: {
        label: true,
        reportLabel: true,
        decimals: true,
        increment: true,
        minMax: true,
        hint: true,
        help: true,
        canHaveRules: true
      }
    },
    SiInputSelect: {
      id: 'SiInputSelect',
      name: 'Select',
      icon: 'arrow_drop_down_circle',
      format: 'text',
      layout: 'default',
      helpMarginAdjust: 16,
      attrs: {
        label: true,
        reportLabel: true,
        hint: true,
        help: true,
        items: true,
        canHaveRules: true
      }
    },
    SiInputAutocomplete: {
      id: 'SiInputAutocomplete',
      name: 'Autocomplete',
      icon: 'arrow_drop_down_circle',
      format: 'text',
      layout: 'default',
      helpMarginAdjust: 16,
      attrs: {
        label: true,
        reportLabel: true,
        items: true,
        hint: true,
        help: true,
        canHaveRules: true
      }
    },
    SiInputRadio: {
      id: 'SiInputRadio',
      name: 'Radio Options',
      icon: 'radio_button_checked',
      format: 'text',
      layout: { xs12: true, sm12: true, lg10: true },
      helpMarginAdjust: 16,
      attrs: {
        label: true,
        reportLabel: true,
        hint: true,
        help: true,
        items: true,
        canHaveRules: true
      }
    },
    SiInputSwitch: {
      id: 'SiInputSwitch',
      name: 'Switch',
      icon: 'toggle_off',
      format: 'boolean',
      layout: { xs12: true, sm12: true, lg10: true },
      helpMarginAdjust: 0,
      attrs: {
        label: true,
        reportLabel: true,
        hint: true,
        help: true,
        items: true
      }
    },
    SiInputCheckbox: {
      id: 'SiInputCheckbox',
      name: 'Checkbox',
      icon: 'check_box',
      format: 'text',
      layout: 'default',
      helpMarginAdjust: 18,
      attrs: {
        label: true,
        reportLabel: true,
        hint: true,
        help: true,
        items: true,
        canHaveRules: true
      }
    },
    SiInputFile: {
      id: 'SiInputFile',
      name: 'File Input',
      icon: 'attachment',
      format: 'file',
      layout: 'default',
      helpMarginAdjust: 16,
      attrs: {
        label: true,
        reportLabel: false,
        hint: false,
        help: true,
        multiple: true,
        canHaveRules: true
      }
    },
    SiAlert: {
      id: 'SiAlert',
      name: 'Alert',
      icon: 'warning',
      format: 'hidden',
      layout: { xs12: true },
      hideHelp: true,
      attrs: {
        label: true,
        description: true
      }
    },
    SiMultiItemInput: {
      id: 'SiMultiItemInput',
      name: 'Multi Line Input',
      icon: 'playlist_add',
      format: 'text',
      layout: { xs12: true },
      helpMarginAdjust: 0,
      hideHelp: true,
      attrs: {
        label: true,
        reportLabel: true,
        fields: true
      }
    },
    SiInputCalculated: {
      id: 'SiInputCalculated',
      name: 'Calculated input',
      layout: 'default',
      icon: 'code',
      attrs: {
        reportLabel: true,
        formula: true
      }
    }
  }
}
